import { generateQuery } from './helperFunctions';

export const registration = {
  getMock: {
    api: 'api/unknown',
    method: 'get',
  },
  profile: {
    api: 'api/profiles',
    method: 'post',
  },
  relations: {
    api: '/api/masters/relations',
    method: 'get',
  },
  medicalConds: {
    api: '/api/masters/category',
    method: 'get',
  },
  subMedicalConds: {
    url: '/api/masters/',
    method: 'get',
    category_id: null,
    get api() {
      return `${
        this.url + this.category_id
      }?with=subtreatments;mutations;stages`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  expertiseIn: {
    api: '/api/masters/doctor',
    method: 'get',
  },
  doctors: {
    api: '/api/masters/doctor',
    method: 'get',
  },
  experts: {
    api: '/api/masters/expert',
    method: 'get',
  },
  addPatients: {
    url: 'api/profiles',
    method: 'post',
    query: {
      url_id: null,
    },
    get api() {
      return `${this.url + generateQuery(this.query)}/disease`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
    // let profileid:1
  },
  addCarer: {
    url: 'api/profiles',
    method: 'post',
    query: {
      url_id: null,
    },
    get api() {
      return `${this.url + generateQuery(this.query)}/disease`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  addDoctors: {
    url: 'api/profiles',
    method: 'post',
    query: {
      url_id: null,
    },
    get api() {
      return `${this.url + generateQuery(this.query)}/info`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  addExperts: {
    url: 'api/profiles',
    method: 'post',
    query: {
      url_id: null,
    },
    get api() {
      return `${this.url + generateQuery(this.query)}/info`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  treatment: {
    api: '/api/masters/treatment',
    method: 'get',
  },
};
export const validation = {
  validateSipUser: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    page: 1,
    get api() {
      return `${this.url}/${this.entityId}/verify/subscription`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};
export const dashboard = {
  getProfile: {
    url: 'api/users/me',
    method: 'get',
    cause: null,
    get api() {
      return `${this.url}?with=avtar;subscribed;aggdonationall;sipSubscribed.sipLatestorder;sipSubscribed.latestorder;activateReward;lastUpdateCount;rewardActivation;occupation;walletBalance;verifiedPhoneNumber;subscriptions;latestOrder;panNumber;qualification;familyMembers;listsubscriptions;donationPreference;latestSubscription;notificationPreference;latestUserPolicyDetails;isOnboarded;show80G;show10BE&sip_cause=medical`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getPortfolio: {
    url: 'api/subscriptions/latest?with=latestorder.campaign',
    method: 'get',
    subId: null,
    cause: null,
    get api() {
      return `${this.url}&search=id:${this.subId}&sip_cause=${this.cause}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getSubscription: {
    url: 'api/subscriptions/count',
    method: 'get',
    cause_name: null,
    get api() {
      return `${this.url}?cause=${this.cause_name}`;
    },
  },
  getCertificate: {
    url: 'api/orders/',
    method: 'get',
    orderId: null,
    get api() {
      return `${this.url + this.orderId}/certificate`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  optRewards: {
    url: 'api/entity/',
    method: 'post',
    entityId: null,
    get api() {
      return `${this.url + this.entityId}/infos`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getDonation: {
    url: 'api/users/me/orders/summary?currency=',
    method: 'get',
    currency: '',
    get api() {
      return `${this.url}${this.currency}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  resumeGiving: {
    url: 'api/users/me/orders/summary?currency=',
    method: 'get',
    currency: '',
    get api() {
      return `${this.url}${this.currency}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  editProfile: {
    url: 'api/users/',
    method: 'put',
    entityId: null,
    get api() {
      return `${this.url + this.entityId}/info`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  editProfilePic: {
    url: 'api/users/',
    method: 'post',
    entityId: null,
    get api() {
      return `${this.url + this.entityId}/media/individual/profile`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  turnOffGiving: {
    url: 'api/subscriptions',
    method: 'delete',
    subId: null,
    get api() {
      return `${this.url}/${this.subId}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  updatePassword: {
    url: 'api/entity',
    method: 'put',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/password/change`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getImpactInfo: {
    api: 'api/users/me/orders?limit=4&orderBy=creation_date&sortedBy=desc&otd_upsell=1',
    method: 'get',
  },
};
export const activity = {
  getActivity: {
    url: 'api/entity/',
    method: 'get',
    entityId: null,
    page: 1,
    get api() {
      return `${this.url + this.entityId}/sip/infos?page=${this.page}&limit=10`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getCampaign: {
    url: 'api/campaigns/',
    method: 'get',
    campId: null,
    page: 1,
    get api() {
      return `${this.url + this.campId}?with=gallery;medicalbill;guardiankyc;beneficiaryrelation;beneficiaryage;leaderboard;campaigner.avtar;beneficiaryname;basicinfo;owner;cause;disease;hospital;manager.entity.avtar;patientNumber;raised&page=${this.page}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};
export const updates = {
  getUpdates: {
    url: 'api/entity/',
    method: 'get',
    entityId: null,
    page: 1,
    get api() {
      return `${this.url + this.entityId}/orders/campaigns/updates?with=campaign.campaigner&page=${this.page}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getCampaignUpdate: {
    url: 'api/entity/',
    method: 'get',
    entityId: null,
    page: 1,
    campaignId: null,
    updateId: null,
    get api() {
      return `${this.url + this.entityId}/orders/campaigns/${this.campaignId}/updates/${this.updateId}?orderBy=id&sortedBy=desc`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  getLikes: {
    url: 'api/campaigns',
    method: 'post',
    campaignId: null,
    updateId: null,
    get api() {
      return `${this.url}/${this.campaignId}/updates/${this.updateId}/like`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};
export const mySip = {
  getAllocatedFundraisers: {
    method: 'get',
    url: 'api/users',
    method: 'get',
    userId: null,
    page: 1,
    limit: null,
    subId: null,
    get api() {
      if (!this.limit) {
        return `${this.url}/${this.userId}/subscriptions/thankyou?with=campaign.raised;campaign.beneficiaryname;campaign.campaigner.avtar;campaign.disease;campaign.customThankyou;campaign.mediaBeneficiary;campaign.gallery&sip_subscription_id=${this.subId}`;
      }
      return `${this.url}/${this.userId}/subscriptions/thankyou?with=campaign.raised;campaign.beneficiaryname;campaign.campaigner.avtar;campaign.disease;campaign.customThankyou;campaign.mediaBeneficiary;campaign.gallery&page=${this.page}&limit=${this.limit}&sip_subscription_id=${this.subId}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getImpactInfo: {
    api: 'api/users/me/orders?with=campaign;campaign.beneficiary;campaign.beneficiaryname;campaign.mediaBeneficiary;campaign.campaigner.avtar;campaign.updatesCount;campaign.basicinfo;campaign.hospital;campaign.viewmedicalbill;campaign.leaderboard;campaign.theater;campaign.storyTitle;campaign.storyDescription&limit=12&orderBy=creation_date&sortedBy=desc',
    method: 'get',
  },
  pledgeMoreSipSubscription: {
    url: 'api/subscriptions/',
    method: 'put',
    subsId: null,
    get api() {
      return `${this.url}${this.subsId}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  cancelSipSubscription: {
    url: 'api/subscriptions/',
    method: 'delete',
    subsId: null,
    reasons: null,
    get api() {
      return `${this.url}${this.subsId}?reason=${this.reasons}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  notificationPreference: {
    url: 'api/users',
    method: 'post',
    entityId: null,
    body: null,
    get api() {
      return `${this.url}/${this.entityId}/settings/notification`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  confirmOTP: {
    url: 'api/verify/otp/token',
    method: 'post',
    body: null,
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  sendOTP: {
    url: 'api/verify/details',
    method: 'post',
    body: null,
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const Updates = {
  updates: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    page: 1,
    limit: null,
    dashboard: false,
    get api() {
      if (this.dashboard) return `${this.url}/${this.entityId}/orders/campaigns/updates?page=${this.page}&limit=${this.limit}&dashboard=${this.dashboard}`;
      return `${this.url}/${this.entityId}/orders/campaigns/updates?with=userLiked;campaign.donorCallScheduled;campaign.beneficiaryname;campaign.beneficiary;campaign.owner;campaign.about;owner;comments&page=${this.page}&limit=${this.limit}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  latestUpdates: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    campaignId: null,
    updateId: null,
    get api() {
      return `${this.url}/${this.entityId}/orders/campaigns/${this.campaignId}/updates/${this.updateId}?orderBy=id&sortedBy=desc`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  askForUpdates: {
    method: 'post',
    url: 'api/fundraisers',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/askupdate`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const Allocation = {
  getList: {
    method: 'get',
    url: 'api/sip/campaigns/allocate',
    method: 'get',
    entityId: null,
    page: 1,
    currency: '',
    get api() {
      return `${this.url}?with=medicalbills&currency=${this.currency?.toUpperCase()}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  sendList: {
    method: 'post',
    url: 'api/sip/entity/',
    method: 'post',
    entityId: null,
    page: 1,
    get api() {
      return this.url + `${this.entityId}/campaigns/allocate`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getAllocatedList: {
    method: 'get',
    url: 'api/sip/entity/',
    method: 'get',
    entityId: null,
    page: 1,
    currency: null,
    get api() {
      return this.url + `${this.entityId}/campaigns/allocate?currency=${this.currency}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  removeAllocatedFunds: {
    method: 'post',
    url: 'api/sip/entity/',
    method: 'delete',
    entityId: null,
    page: 1,
    get api() {
      return this.url + `${this.entityId}/campaigns/allocate`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

// export const Rewards = {
//   getAllRewards: {
//     method: 'get',
//     url: 'api/entity',
//     entityId: null,
//     cause: null,
//     get api() {
//       return `${this.url}/${this.entityId}/rewards?sip_cause=${this.cause}`;
//     },
//     set addQuery({ key, payload }) {
//       this.query[key] = payload;
//     },
//   },
//   activateTeleConsult: {
//     method: 'post',
//     url: 'api/entity',
//     entityId: null,
//     rewardId: null,
//     get api() {
//       return `${this.url}/${this.entityId}/rewards/${this.rewardId}/activate`;
//     },
//     set addQuery({ key, payload }) {
//       this.query[key] = payload;
//     },
//   },

//   claimReward: {
//     method: 'post',
//     url: 'api/entity',
//     entityId: null,
//     rewardId: null,
//     get api() {
//       return `${this.url}/${this.entityId}/rewards/${this.rewardId}/claim`;
//     },
//     set addQuery({ key, payload }) {
//       this.query[key] = payload;
//     },
//   },
//   getRewardInfo: {
//     method: 'get',
//     url: 'api/entity',
//     entityId: null,
//     rewardId: null,
//     type: '',
//     cause: null,
//     get api() {
//       return `${this.url}/${this.entityId}/rewards/${this.rewardId}?sip_cause=${this.cause}`;
//     },
//     set addQuery({ key, payload }) {
//       this.query[key] = payload;
//     },
//   },
//   submitTransactionDetails: {
//     method: 'post',
//     url: 'api/entity',
//     entityId: null,
//     rewardId: null,
//     get api() {
//       return `${this.url}/${this.entityId}/rewards/${this.rewardId}/claim`;
//     },
//     set addQuery({ key, payload }) {
//       this.query[key] = payload;
//     },
//   },
// };

export const SipProtect = {
  getHospitalList: {
    method: 'get',
    url: 'api/sip/hospitals?city=',
    method: 'get',
    city: '',
    hospital_search_term: '',
    page: 1,
    get api() {
      if (this.hospital_search_term) {
        return `${this.url}${this.city}&page=${this.page}&hospital_search_term=${this.hospital_search_term}`;
      }
      return `${this.url}${this.city}&page=${this.page}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getClaimHistory: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/sip/reward/claim?with=entity`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getPendingClaims: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/sip/reward/claim/protect?with=entity`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  activateForm: {
    url: 'api/users',
    method: 'put',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/info`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const Referral = {
  myInvites: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/referrals`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getLeaderboard: {
    method: 'get',
    url: 'api/referrals/summary',
    method: 'get',
    entityId: null,
    campaignId: null,
    updateId: null,
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  inviteFriends: {
    method: 'get',
    url: 'api/entity',
    method: 'post',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/invites`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getInvites: {
    method: 'get',
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/invites?with=entity`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const systemEventCollection = {
  sendEvent: {
    method: 'post',
    url: 'actions/collect',
    eventName: null,
    page_name: null,
    entityType: null,
    entity_id: '',
    info_1: null,
    info_2: null,
    info_3: null,
    info_4: null,
    isEvent: true,
    referrer_page: '',
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    em: '',
    to: '',
    platform: '',
    ab_testname: null,
    ab_value: null,
    reward_name: '',
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const cityName = {
  getCityName: {
    method: 'get',
    url: 'api/third_party/iplocation',
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const VerifyVPA = {
  verifyVPA: {
    method: 'post',
    url: 'api/verify/vpa',
    method: 'post',
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const inactiveUser = {
  submitTelecall: {
    method: 'post',
    url: 'api/lead',
    get api() {
      return `${this.url}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  pauseSubscription: {
    method: 'put',
    url: 'api/entity',
    entityId: null,
    subId: null,
    get api() {
      return `${this.url}/${this.entityId}/subscriptions/${this.subId}/activate`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const myDonations = {
  getMyDonations: {
    url: 'api/entity/',
    method: 'get',
    entityId: null,
    page: 1,
    get api() {
      return `${this.url + this.entityId}/donations?page=${this.page}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  requestRefund: {
    url: 'api/campaigns',
    method: 'post',
    body: null,
    campId: null,
    orderId: null,
    get api() {
      return `${this.url}/${this.campId}/orders/${this.orderId}/donors/refunds`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

  makeAnonymous: {
    url: 'api/users',
    method: 'put',
    body: null,
    entityId: null,
    orderId: null,
    get api() {
      return `${this.url}/${this.entityId}/orders/${this.orderId}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const walletSummary = {
  getWalletSummary: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    page: 1,
    get api() {
      return `${this.url}/${this.entityId}/wallet/ledger?page=${this.page}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const explore = {
  url: 'api/campaigns?tags=trending&currency=inr',
  method: 'get',
  ku: null,
  get api() {
    return `${this.url}&_ku=${this.ku || ''}&with=basicInfo`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const trending = {
  url: `api/campaigns?tags=trending&currency=${localStorage.getItem('currency') || 'inr'}`,
  method: 'get',
  ku: null,
  get api() {
    return `${this.url}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const featuredCampaigns = {
  url: 'api/campaigns?tags=featured&limit=3&with=beneficiaryname;theater;storyWidget;mediaBeneficiary',
  method: 'get',
  ku: null,
  get api() {
    return `${this.url}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const onDemandSub = {
  url: 'api/entity',
  method: 'post',
  entityId: null,
  body: null,
  get api() {
    // return `${this.url}/${this.entityId}/subscriptions/payments?amount=${this.amount}&currency=${this.currency}&sip_cause=${this.sipCause}${this.subId ? '&subscription_id=' + this.subId : ''}`;
    return `${this.url}/${this.entityId}/subscriptions/payments`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const multiCause = {
  url: 'api/entity',
  method: 'get',
  entityId: null,
  currency: null,
  get api() {
    return `${this.url}/${this.entityId}/subscriptions?currency=${this.currency}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const Comments = {
  getLatestComments: {
    url: 'api/fundraisers',
    method: 'get',
    campId: null,
    updateId: null,
    get api() {
      return `${this.url}/${this.campId}/updates/${this.updateId}/comments`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  addComments: {
    url: 'api/fundraisers',
    method: 'post',
    campId: null,
    updateId: null,
    get api() {
      return `${this.url}/${this.campId}/updates/${this.updateId}/comments`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const causes = {
  url: 'api/causes/20?with=child',
  method: 'get',
  get api() {
    return `${this.url}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

// --------------------Good Deeds-------------------------//

export const goodDeeds = {
  deedsDashboard: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    week: null,
    get api() {
      if (!this.week) return `${this.url}/${this.entityId}/deeds/dashboard`;
      return `${this.url}/${this.entityId}/deeds/dashboard?week=${this.week}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  getQuestions: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    week: null,
    get api() {
      return `${this.url}/${this.entityId}/deeds?week=${this.week}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  updateAnswer: {
    url: 'api/entity',
    method: 'put',
    entityId: null,
    deedId: null,
    week: null,
    get api() {
      return `${this.url}/${this.entityId}/deeds/${this.deedId}?week=${this.week}`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  timeLine: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/deeds/timeline`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
};

export const successStories = {
  api: 'api/fundraisers/success-story?with=successInfo;successStoryImage;campaigner;raised&limit=4&currency=INR',
  method: 'get',
};

// --------------------HealthFirst-------------------------//

export const healthfirst = {
  planPolicies: {
    url: 'api/health',
    method: 'get',
    get api() {
      return `${this.url}/plans`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },
  plansDetails: {
    url: 'api/entity',
    method: 'get',
    entityId: null,
    get api() {
      return `${this.url}/${this.entityId}/policies/details`;
    },
    set addQuery({ key, payload }) {
      this.query[key] = payload;
    },
  },

};

export const urgentDonation = {
  url: 'api/campaigns',
  method: 'get',
  entityId: null,
  get api() {
    return `${this.url}?limit=4&tags=featured&with=beneficiaryname;storyWidget;gallery`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const taxCertificatesZip = {
  url: 'api/entity',
  method: 'get',
  entityId: null,
  taxReceiptType: null,
  get api() {
    return `${this.url}/${this.entityId}/download/${this.taxReceiptType}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};

export const verifyMobile = {
  method: 'put',
  entityId: null,
  get api() {
    return `api/users/${this.entityId}/verify/mobile`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  }
};

export const getBBPSLink = {
  method: 'get',
  entityId: null,
  get api() {
    return `api/setu/${this.entityId}/initiate?onboard=1`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  }
};

export const getSSOTokenForHubble = {
  url: 'api/entity',
  method: 'get',
  entityId: null,
  isOnboarded: null,
  get api() {
    return `${this.url}/${this.entityId}/sso/token${this.isOnboarded && this.isOnboarded?.length ? this.isOnboarded : ''}`;
  },
  set addQuery({ key, payload }) {
    this.query[key] = payload;
  },
};
